export function loadScript(src) {
  (function(){
    let d = document
    let s = d.createElement('script')
    s.src=src
    s.async=1
    d.getElementsByTagName('head')[0].appendChild(s);})()
}